export default __webpack_public_path__ + "static/media/phone.3b89be41.svg";